import {
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  Icon,
  Portal,
  Flex,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import NoHTMLScroll from '../../../../../../../common/src/components/NoHTMLScroll';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
  onEdit: () => void;
  onRemove: () => void;
  isDisabled?: boolean;
}

const TableItemActionsMenu: React.FC<React.PropsWithChildren<Props>> = ({
  question,
  onEdit,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <NoHTMLScroll />
      <Flex justify="flex-end" onClick={(e) => e.stopPropagation()}>
        <Menu isLazy>
          <MenuButton
            as={IconButton}
            variant="white"
            aria-label="Options"
            icon={<Icon name="IconOthersFilled" boxSize={6} />}
            size="sm"
          />
          <Portal>
            <MenuList>
              <MenuItem
                icon={<Icon name="GeneralActionsEdit" />}
                onClick={onEdit}
              >
                {t(`EDIT-VIEW`)}
              </MenuItem>
              <MenuItem
                color="danger.main"
                icon={<Icon name="GeneralActionsThrash" />}
                onClick={onRemove}
                isDisabled={question.rules.is_disabled}
              >
                {t('REMOVE')}
              </MenuItem>
            </MenuList>
          </Portal>
        </Menu>
      </Flex>
    </>
  );
};

export default TableItemActionsMenu;
